import { clsx } from 'clsx';
import { type FC } from 'react';

import {
  Overlay,
  type OverlayBGC,
} from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/Overlay';

import { SlideImage } from '../SlideImage';

import { type SlideImageWithOverlayProps } from './types';

import styles from './SlideImageWithOverlay.css';

export const SlideImageWithOverlay: FC<SlideImageWithOverlayProps> = props => {
  const { background, content, isDeoptimised, src, alt } = props;

  let overlayBgc: OverlayBGC;
  let blurPhoto = false;

  switch (background) {
    case 'red':
    case 'gray':
      overlayBgc = background;

      break;

    case 'blur':
      blurPhoto = true;
      overlayBgc = 'black_40';

      break;
  }

  return (
    <div className={clsx(styles['container'], blurPhoto && styles['blur-photo'])}>
      <SlideImage alt={alt} isDeoptimised={isDeoptimised} src={src} />
      <Overlay bgc={overlayBgc}>{content}</Overlay>
    </div>
  );
};
